import { registerAngularModule } from '/vodalys/vparcel/source.init.mjs'

import { declareVueComponent } from '/vodalys/vvuejs'

import { VuMeter, log } from './src/main.mjs'
import './vvvumeter.main.vrun.scss'
import './vvvumeter.main.vrun.tooltip.scss'

declareVueComponent('Vumeter', async () => import('./Vumeter.vue'))


// on est obliger de faire ça pour recuperer le template "pure" sans tranfromation de parcel
// ça marche parceque parcel va chercher le fichier dans le dossier source et l'inline a la compilation
import fs from 'fs';
const template = fs.readFileSync(__dirname + '/vvvumeter.main.vrun.html', 'utf8');


const m = angular.module('vvvumeter.main.vrun', [])
registerAngularModule('vvvumeter.main.vrun')

m.service('vvvumeter.main.vrun.factory', function () {
    return function factory(id) {
        var instance = {
            'id': id,
        }
        return instance
    }
})

class VumeterController {
    constructor($element, $scope, vRunScope, $timeout) {

        this.onVideoPlayHandler = {
            handleEvent: () => {
                log('video onPlay')
                if (this.vumeter && this.vumeter.isRunning()) {
                    return
                }
                else if (this.vumeter && this.vumeter.isSuspended()) {
                    this.resumeStuff()
                    return
                }
                this.reinit()
            }
        }
        this.onVideoPauseHandler = {
            handleEvent: () => {
                log('video onPause')
                if (this.vumeter.source instanceof MediaElementAudioSourceNode) {
                    this.pauseStuff()
                }
                else {
                    this.stopStuff()
                }

            }
        }

        this.onVolumeChanged = () => {
            console.log('volume changed !!!', this)
            this.muted = this.vumeter.audio.muted
            $timeout()
        }

        this.instance = vRunScope.bindScope($scope, $scope.$ctrl.component['instance_id'])
        this.init(...arguments)

        this.reinit = async () => {
            log('reinit')
            if (this.vumeter) {

                this.stopStuff()
            }
            this.displayEnableVumeter = false
            this.init($element, $scope, vRunScope, $timeout)
        }
    }


    async init($element, $scope, vRunScope, $timeout) {


        try {
            this.vumeter = await new VuMeter($element)
        }
        catch (e) {
            console.warn(e)
            return
        }


        if (!this.vumeter) {
            console.warn('Vumeter not initialized')
            this.displayEnableVumeter = true
            $timeout()
            return;
        }
        else if (this.vumeter.noAudio) {
            this.displayEnableVumeter = true
            this.displayNoAudio = true
            $timeout()
            return;
        }

        this.vumeter.video.play() 

        // console.warn('its fine at this point')

        $scope.$on('$destroy', () => {
            this.stopStuff();
            this.destroyed = true;
            video.removeEventListener('play', this.onVideoPlayHandler)
            video.removeEventListener('pause', this.onVideoPauseHandler)
            audio.removeEventListener('volumechange', this.onVideoPauseHandler)
        })

        const { audio, video, canvas } = this.vumeter


        video.addEventListener('play', this.onVideoPlayHandler)
        video.addEventListener('pause', this.onVideoPauseHandler)
        audio.addEventListener('volumechange', this.onVolumeChanged)


        // dans le cas du webrtc il faut hijacker le player instance 
        // console.info('player ready')

        // console.info('!video.src', !video.src)
        // console.info('!video.srcObject', !video.srcObject)

        while (!video.src && !video.srcObject && !this.destroyed) {
            await new Promise(resolve => setTimeout(resolve, 500))
        }

        if (!video.src) {


            // on force le mute sur le <video /> (le son du srcObject est rediriger vers une balise audio
            if (this.instance['vvvumeter:player'].forceMute) {
                this.instance['vvvumeter:player'].forceMute(true)
            } else if (this.instance['vvvumeter:player'].mute) {
                this.instance['vvvumeter:player'].mute(true)
            } else {
                video.muted = true
            }

            // on hijack le volume
            this.instance['vvvumeter:player']['volume'] = (volume) => {
                audio.volume = volume
                video.volume = volume
                log('update volume', volume)
            }

            audio.volume = video.volume

            //
        }





    }

    pauseStuff() {
        if (this.vumeter) {
            log('pause audiocontext')
            this.vumeter.audioContext.suspend();
        }
    }

    resumeStuff() {
        if (this.vumeter) {
            log('resume audiocontext')
            this.vumeter.audioContext.resume();
        }
    }

    stopStuff() {
        if (this.vumeter) {
            this.vumeter.stop();
            this.vumeter = undefined
        }
    }

    toggleMute($event) {
        log(`toggle mute3 to ${!this.vumeter.audio.muted}`, this)

        this.vumeter.audio.muted = !this.vumeter.audio.muted

        if ($event) {
            $event.target.blur()
        }
    }
}


m.component('vvvumeterComponent', {
    bindings: {
        component: '<',
        handler: '<'
    },
    controller: VumeterController,
    controllerAs: '$ctrl',
    template,
})

m.directive('vvvumeterTooltip', function () {

    return {
        scope: {},
        transclude: true,
        template: `<ng-transclude/><i/>`
    }
})
